import { BlogWrapper } from "../../../../src/collections/blog/Blog.style.js";
import SignedBook from "../../../../src/collections/blog/2020/2020-08-11-my-journey-from-a-contributor-to-a-maintainer/pic2.jpeg";
import * as React from 'react';
export default {
  BlogWrapper,
  SignedBook,
  React
};